import React, { Fragment, useState } from "react";
import { circles } from "../../pages/inmersys/new-project/indexAssets";
import { createColumn } from "../../helpers/projectTableBySpaceHelper";
const { circleGreen, circlePurple, circleBlue, circleRed } = circles;

export const useColumnsProjectTable = () => {
    const [columns, setColumns] = useState([]);

    const [peopleDataFilters, setPeopleDataFilters] = useState({
        peopleInCharge: {},
        peopleInChargeProject: {},
        leaders: {},
    });

    const statusImageFormatter = (text, hasComments) => {
        if (!text) {
            return null;
        }

        const statusImages = {
            activo: circleBlue,
            pausa: circlePurple,
            concluido: circleGreen,
            cancelado: circleRed,
        };

        const image = statusImages[text.toLowerCase()] || null;
        const isConcluded = text.toLowerCase() === "concluido";
        const doesNeedComment = !hasComments && isConcluded;
        if (!image) return <Fragment />;

        return (
            <div className="relative flex justify-center items-center w-fit ">
                {doesNeedComment && <p className="w-3 h-3 rounded-full bg-red-500 absolute top-[-5px] right-[-5px]"></p>}
                <img src={image} alt={text} />
            </div>
        );
    };

    const updateColumnsTable = ({ userName = null, people = null, filters = null, isAdmin = false, actionDeleteProyect = null }) => {
        let getPeopleColumns = peopleDataFilters;

        let filtersTable = {
            commercial: [],
            leader: [],
            responsible: [],
            status: [],
        };

        if (people) {
            setPeopleDataFilters(people);
            getPeopleColumns = people;
        }

        if (filters) {
            filtersTable = filters;
        }

        if (userName) {
            const nameLeader = people["leaders"].users.find((user) => user.name === userName);
            if (nameLeader) {
                filtersTable["leader"] = [nameLeader.name];
            }
        }

        setColumns(createColumn({ ...getPeopleColumns, filtersTable, statusImageFormatter, isEdit: isAdmin, actionDeleteProyect }));
    };

    return { updateColumnsTable, columns };
};
